import React from 'react';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import cookie from 'react-cookies';

function Header(props) {
  const { page } = props;
  return (
    <div className='header'>
      <div className='page-name'>{`${page.name || ''}`}</div>
      <div className='right-nav'>
        <span className='name'>Hello {cookie.load('username')}</span>
        {/* <span className="name">Hello </span> */}
        <span>
          <AccountCircleIcon />
        </span>
      </div>
    </div>
  );
}
export default Header;
